import axiosInstance from '../axiosInstance';
import { BaseService } from './baseService';

class ContactImportRowsService extends BaseService<
	ContactImportRow,
	'contactImportRowID',
	'contactImportRows'
> {
	constructor() {
		super('contactImportRowID', 'contactImportRow', 'contactImportRows');
	}

	async getAllByImportId(
		importID: number,
		queryParams?: Record<string, string>,
	) {
		const response = await axiosInstance.get(
			`/app/contactImports/${importID}/contactImportRows`,
			{
				params: queryParams,
			},
		);

		return response.data;
	}
}

export default new ContactImportRowsService();
